export type TContractType = "br-services" | "las-services" | "br-materials" | "las-materials" | "br-materials-simple";
export interface IContractTypeSupported {
    BR_SERVICES: TContractType;
    LAS_SERVICES: TContractType;
    BR_MATERIALS: TContractType;
    LAS_MATERIALS: TContractType;
    BR_MATERIALS_SIMPLE: TContractType;
}
export const contractTypeSupported: IContractTypeSupported = {
    BR_SERVICES: "br-services",
    LAS_SERVICES: "las-services",
    BR_MATERIALS: "br-materials",
    LAS_MATERIALS: "las-materials",
    BR_MATERIALS_SIMPLE: "br-materials-simple"
}